export default __webpack_public_path__ + "static/media/totalSections.f1a20563.svg";